import React from 'react';
// import MapContainer from '../MapContainer/MapContainer';
import './Footer.scss';

import logo from '../../assets/img/logo-clickHogar-blanco.png';
import { BsFacebook, BsInstagram } from 'react-icons/bs';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="row">

            <div className="col-md-3 my-3 my-md-5 text-center text-center">
              <Link to="/">
                <img
                  className="footer__logo"
                  src={logo}
                  alt="Click Hogar - Bahía Blanca, Argentina."
                  loading="lazy"
                  decoding="async"
                />
              </Link>
            </div>

            <div className="col-md-3 mt-2 mb-1 mt-sm-5 mb-sm-3 text-center text-md-left">
              <h3 className="footer__title">Contacto</h3>
              <address>
                Brasil 978<br />
                Bahía Blanca, Argentina <br />
                <a className="mt-1" href="mailto:clickhogarbahiablanca@gmail.com?Subject=Consulta%20desde%20clickhogarbahia.com.ar&body=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20">clickhogarbahiablanca@gmail.com</a>
              </address>
            </div>

            <div className="col-md-2 mt-2 mb-1 mt-sm-5 mb-sm-3 text-center text-md-left">
              <h3 className="footer__title">Horario:</h3>
              <p>
                {/* Lunes a viernes de<br />
                09:00 hs a 12:30 hs<br />
                16:00 hs a 20:00 hs */}
                Lunes a Viernes de 9 a 17hs<br />
                HORARIO CORRIDO
              </p>
            </div>

            <div className="col-md-4 mt-2 mb-1 mt-sm-5 mb-sm-3 text-center text-md-left">
              <h3 className="footer__title">Seguinos:</h3>
              <p>
                <a
                  className="footer__icon mt-2"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/clickhogarbahiablanca"
                  aria-label="Seguinos en Facebook"
                  title="Seguinos en Facebook"
                >
                  <BsFacebook /> <small>/Click Hogar Bahía Blanca</small>
                </a>
                <a
                  className="footer__icon mt-2"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/clickhogarbahiablanca/"
                  aria-label="Seguinos en Instagram"
                  title="Seguinos en Instagram"
                >
                  <BsInstagram /> <small>clickhogarbahiablanca</small>
                </a>
              </p>
            </div>

            {/* <div className="col-md-3 mt-2 mb-1 mt-sm-5 mb-sm-3 text-center">
              <h3 className="footer__title">Enlaces</h3>
              <ul className='list-unstyled'>
                <li><a className="footer__link" href="">Inicio</a></li>
                <li><a className="footer__link" href="">Productos</a></li>
                <li><a className="footer__link" href="">Contacto</a></li>
              </ul>
            </div>

            <div className="col-md-3 mt-2 mb-1 mt-sm-5 mb-sm-3 text-center">
              <h3 className="footer__title">Cuenta</h3>
              <ul className='list-unstyled'>
                <li><a className="footer__link" href="">Iniciar Sesión</a></li>
                <li><a className="footer__link" href="">Registro</a></li>
                <li><a className="footer__link" href="">Carrito</a></li>
              </ul>
            </div> */}

          </div>
        </div>

        <div className="footer__copy">
          <div className="container">
            <div className="row">
              <div className="col-md-8 text-center text-md-left">
                Click Hogar ©{new Date().getFullYear()} | Todos los derechos reservados.
              </div>
              <div className="col-md-4 text-center text-md-right">
                Desarrollado por: <a href="https://www.paradigma.com.ar/" target="_blank" rel="noopener noreferrer">Paradigma del Sur S.A. <img src="https://paradigma.com.ar/img/favicon.ico" height="16" alt="Paradigma del Sur" loading="lazy" decoding="async" /></a>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <a
        title="Whatsapp"
        href="https://api.whatsapp.com/send?phone=5492915327990&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20"
        className="float float_1"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Consultar por WhatsApp"
      >
        <i className="fa fa-whatsapp my-float"></i>
      </a>
      <a
        title="Email"
        // href="https://api.whatsapp.com/send?phone=542915111792&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20"
        href="mailto:clickhogarbahiablanca@gmail.com?Subject=Consulta%20desde%20clickhogarbahia.com.ar&body=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20"
        className="float float_2"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Consultar por correo electrónico"
      >
        <i className="fa fa-envelope-o my-float"></i>
      </a>
    </>
  );
};

export default Footer;
